<template>
    <div :ref="stepName" style="position:relative">
        <div class="form-header">
            <h3 class="title">Découvrez Testachats<br>Résiliable à tout moment !</h3>
            <strong>Et choisissez votre cadeau de bienvenue parmi des dizaines de marques.</strong>
        </div>
        <NameForm></NameForm>
        <b-loading :is-full-page="false" v-model="loading"></b-loading>
    </div>
</template>

<script>
import mixin from "../../../travel_step_mixin";
import {Text} from "../../../../../../models/fields/Text";
import NameForm from "./NameForm";
import animation_engine_mixin from "../../../animation_engine_mixin";
import animation_step_style_mixin from "../../../animation_step_style_mixin";

export default {
    components: {NameForm},
    mixins: [mixin,  animation_engine_mixin, animation_step_style_mixin],
}
</script>
